import sanitize from 'sanitize-html';
export const DEFAULT_ALLOWED_TAGS = sanitize.defaults.allowedTags.concat([
    'iframe',
    'img',
    'p',
    'figure',
]);
export const DEFAULT_ALLOWED_ATTRIBUTES = Object.assign(Object.assign({}, sanitize.defaults.allowedAttributes), { iframe: [
        'src',
        'class',
        'frameborder',
        'allow',
        'allowfullscreen',
        'webkitallowfullscreen',
        'mozallowfullscreen',
    ], img: ['*'], p: ['*'], figure: ['class'], a: sanitize.defaults.allowedAttributes.a.concat([
        'id',
        'class',
        'data-card-width',
        'data-card-controls',
    ]) });
export const sanitizeHtml = (content) => {
    return sanitize(content, {
        allowedTags: DEFAULT_ALLOWED_TAGS,
        allowedAttributes: DEFAULT_ALLOWED_ATTRIBUTES,
    });
};
